import { actions } from "./action-list";

export function setAllCityConfigs(value) {
  return {
    type: actions.FETCH_ALL_CITY_CONFIGS,
    value,
  };
}

export function setCityAgencies(value) {
  return {
    type: actions.FETCH_CITY_AGENCIES,
    value,
  };
}

export function upsertCityConfigs(value) {
  return {
    type: actions.UPSERT_CITY_CONFIGS,
    value,
  };
}
